/**
 * Global Imports
*/

import React, { useEffect, useContext, useState } from 'react';
import { Formik, Form } from 'formik';
import { useRouteMatch } from 'react-router-dom';

/**
 * Root Imports
*/

import { PageContext } from '~/components/PageProvider';
import { CssClassName } from '~/util/Css';
import { Box } from '~/components/Widget';
import { Table, TableBodyRow, TableBodyLink } from '~/components/Widget/Table';
import { Input, Submit } from '~/components/Form';

/**
 * Local Imports
*/

import { UserContext } from '../../Providers/UserProvider';

/**
 * Locals
*/

/**
 * 
 */
function CreateUser(props) {
  /** Contexts **/
  
  const provider = useContext(UserContext);

  /** States **/
  
  const [ error, setError ] = useState(null);

  /** Formik **/

  const initialValues = {
    email: '',
    password: ''
  };

  /** Event Handlers **/
  
  /**
   * 
   */
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    setError(null);

    provider.store(values)
      .then(() => resetForm())
      .catch(error => setError(error.response.data))
      .finally(() => setSubmitting(false))
    ;
  };

  /** Renderers **/

  /**
   * 
   */
  const renderForm = ({ isSubmitting, ...formik }) => (
    <Form>
      <Input
        name='email'
        placeholder='Email Address'
        className='form-input'
        containerClassName='mb-4'
        formik={ formik }
      />

      <Input
        name='password'
        placeholder='Password'
        className='form-input'
        containerClassName='mb-4'
        formik={ formik }
      />

      <Submit
        className={
          CssClassName([
            'w-full btn btn-blue', isSubmitting && 'loading'
          ])
        }
        label='Create Account'
        disabled={ isSubmitting }
      />
    </Form>
  );

  /** Output **/

  return (
    <Formik initialValues={ initialValues } onSubmit={ handleSubmit }>
      { renderForm }
    </Formik>
  );
}

/**
 * Exports
*/

/**
 * 
 */
export function IndexUser(props) {
  /** Contexts **/
  
  const provider = useContext(UserContext);
  const page = useContext(PageContext);
  const match = useRouteMatch();
  
  /** Side-Effects **/

  useEffect(() => {
    handleMount();
  }, []);
  
  /** Event Handlers **/
  
  /**
   * 
   */
  const handleMount = () => {
    page.change({
      group: 'users',
      breadcrumbs: 'Users'
    });
  };
  
  /**
   * 
   */
  const renderTable = () => (
    <Table thead={[ 'Email', 'Created At', 'Updated At' ]}>
      {
        provider.users.map((user, index) => (
          <TableBodyRow key={ index }>
            <TableBodyLink to={ `${ match.path }/${ user.id }` }>
              { user.email }
            </TableBodyLink>
            <TableBodyLink to={ `${ match.path }/${ user.id }` }>
              { user.created_at }
            </TableBodyLink>
            <TableBodyLink to={ `${ match.path }/${ user.id }` }>
              { user.updated_at }
            </TableBodyLink>
          </TableBodyRow>
        ))
      }
    </Table>
  );

  /**
   * 
   */
  const renderReady = () => (
    <div className='flex'>
      <Box className='flex-shrink w-2/6 mr-2'>
        <CreateUser />
      </Box>
      <div className='w-4/6 ml-2'>
        { renderTable() }
      </div>
    </div>
  );
  
  /** Output **/
  
  return provider.users.length ? renderReady() : null;
}